<template>
  <div class="predictiveBody">
    <div class="staBoxHeaderBox">
      <div class="header-left">
        <i class="el-icon-s-data header-icon"></i>
        <span class="header-title">光伏电站精细化光伏预测平台</span>
      </div>
      <div class="header-center">
        <div class="nav-tabs">
          <div class="nav-tab" @click="goToStatistics">
            <i class="el-icon-data-analysis"></i>
            <span>查询统计</span>
          </div>
          <div class="nav-tab active">
            <i class="el-icon-s-marketing"></i>
            <span>预测分析</span>
          </div>
        </div>
      </div>
      <div class="header-right">
        <el-button type="text" class="back-btn" @click="goBack">
          <i class="el-icon-back"></i>
          返回首页
        </el-button>
      </div>
    </div>
    <div class="staMainBox">
      <div class="stasildBox">
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          router
        >
          <el-menu-item index="/Predictive/VerificationResult">
            <i class="el-icon-setting"></i>
            <span slot="title">检验结果</span>
          </el-menu-item>
          <el-menu-item index="/Predictive/MonthlyAssessment">
            <i class="el-icon-s-check"></i>
            <span slot="title">月底考核</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="stacardBox">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Predictive',
  computed: {
    activeMenu() {
      return this.$route.path
    }
  },
  methods: {
    goToStatistics() {
      this.$router.push({ name: 'Statistics' })
    },
    goBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style>
.stasildBox {
  height: 100%;
  width: 15%;
}
.stacardBox {
  height: 100%;
  width: 85%;
  padding: 15px;
}
.staMainBox {
  height: 92vh;
  width: 100%;
  background-color: #fff;
  display: flex;
}
.stasildBox .el-menu-item {
  font-size: 16px;
}
.stasildBox .el-menu-item i {
  font-size: 18px;
}
.staBoxHeaderBox {
  height: 8vh;
  width: 100%;
  background: linear-gradient(135deg, #0f1f39 0%, #1a3a5c 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
}
.header-left {
  display: flex;
  align-items: center;
}
.header-icon {
  font-size: 28px;
  color: #00d8ff;
  margin-right: 12px;
}
.header-title {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 2px;
}
.header-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-tabs {
  display: flex;
  gap: 20px;
}
.nav-tab {
  display: flex;
  align-items: center;
  padding: 10px 24px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 15px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
  border: 1px solid transparent;
}
.nav-tab:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}
.nav-tab.active {
  color: #00d8ff;
  background-color: rgba(0, 216, 255, 0.15);
  border-color: rgba(0, 216, 255, 0.4);
}
.nav-tab i {
  margin-right: 8px;
  font-size: 16px;
}
.header-right {
  display: flex;
  align-items: center;
}
.back-btn {
  color: rgba(255, 255, 255, 0.8) !important;
}
.back-btn:hover {
  color: #00d8ff !important;
}
</style>
